import { generatePath, type Route } from 'react-resource-router';

/**
 * Create route entry with component/resources/etc. override
 * @param {Route} baseRoute - base route object that contains matching info
 * @param {Partial<Route>} opts - route definition to fill/override
 */
export const createEntry = (baseRoute: Route, opts: Partial<Route>): Route =>
	Object.assign(baseRoute, opts);

/**
 * Alias of generatePath
 * Converts /jira/software/projects/:projectKey/boards/:boardId to /jira/software/projects/ABC/boards/100.
 * Allows to re-use route object in code that needs a real path, without ':parameter' parts in it.
 *
 * @param route
 * @param pathParamValues - object, e.g. { projectKey: 'ABC' }, to replace parameters in the route path with values.
 */
export const getPathFromRoute = (
	route: Route,
	pathParamValues: Record<string, string | number> = {},
) => generatePath(route.path, pathParamValues);
